(function (){
    "use strict";
    angular.module('swif.interventions')
        .controller('InterventionCostEditController', InterventionCostEditController);

    function InterventionCostEditController ($scope, openbase) {
        'ngInject';
        console.log('init InterventionCostEditController');
        var $ctrl = this;
        $ctrl.model = $scope.model;
        $ctrl.formatNameChoices = openbase.utils.selectOneFormatNameChoice;
        $ctrl.selected = {};
        if (!$ctrl.model._equipments) {
            $ctrl.model._equipments = [];
        }
        if (!$ctrl.model._consumables) {
            $ctrl.model._consumables = [];
        }
        $ctrl.filters = {
            equipment: {fields:  ['id', 'name', 'complete_name', 'equipment_reference', 'is_active']}
        };
        //TODO: add real object saved on the server
        $scope.$watch('$ctrl.selected.equipment_id', function (newV) {
            if (newV) {
                delete $ctrl.selected.equipment_id;
                $ctrl.model._equipments.push({name: newV[1]});
            }
        });
        $scope.$watch('$ctrl.selected.consumable_id', function (newV) {
            if (newV) {
                delete $ctrl.selected.consumable_id;
                $ctrl.model._consumables.push({name: newV[1]});
            }
        });
    }

})();
